/* Copyright (c) Trimble Inc. All rights reserved. */

import { ButtonProps, useTheme } from '@material-ui/core';
import clsx from 'clsx';
import React from "react";

interface ModusIconProps extends ButtonProps {
  name: string;
  className?: string;
  color?: "primary"|"secondary";
}

/**
 * @component ModusIcon
 * @param name - Icon Name referred in Modus site
 * @returns Modus Icon in SVG Format
 * @refer https://modus-icons.trimble.com/ for icon names
 */
export const ModusIcon: React.FC<ModusIconProps> = ({
  name,
  className,
  color,
  ...props
}) => {
  const theme =  useTheme();
  return (
    <i
      className={clsx(['modus-icons', className])}
      aria-hidden="true"
      style={{color: color==="primary"? theme.palette.primary.dark:  color }}
      {...props}
    >
      {name}
    </i>
  );
};

export default ModusIcon;
